import React from 'react';
import dynamic from 'next/dynamic';
import { observer, useStoreState } from 'base/store';
import PageHeader, { IPageHeaderProps } from 'app/components/common/PageHeader';
import PageFooter from 'app/components/common/PageFooter';
import CheckoutHeader from '@app/common/CheckoutLayout/CheckoutHeader';
import { Copyright } from '@base/common/Copyright';
import DefaultLoading from '@base/common/DefaultLoading';
import styles from './index.module.less';
import SideWidgets from '@app/common/SideWidgets';
import FloatMiniEntrance from '@base/common/FloatMiniEntrance';
import { OpeningPopup } from '@base/common/OpeningPopup';
import AgeGatePopup from '@pro/age-gate/AgeGatePopup';

const GoogleOneTapLogin = dynamic(() => import('@base/GoogleOneTapLogin'), { ssr: false });

export type BaseLayoutProps = IPageHeaderProps & {
    header?: React.ReactElement | false;
    footer?: React.ReactElement | false;
    loading?: boolean;
    showSideWidgets?: boolean;
    children?: React.ReactElement;
};

const BaseLayout: React.FC<BaseLayoutProps> = (props) => {
    const { header, footer, loading: propsLoading, headerProps, showSideWidgets = true } = props
    const { pageLoading, pageLayout, showOpeningPopup = true } = useStoreState('rootStore');
    const loading = propsLoading || pageLoading;
    const isDefaultLayout = pageLayout === 'default';

    return (
        <div className={styles[`layout-${pageLayout}`]}>

            {/* Google One Tap 一键式登录 */}
            <GoogleOneTapLogin/>

            {header === false
                ? null
                : (header || (isDefaultLayout ? <PageHeader headerProps={headerProps}/> : <CheckoutHeader/>))
            }

            {/* 年龄限制弹窗 */}
            <AgeGatePopup pageProps={(props.children as any)?.props}/>

            {loading ? <DefaultLoading type="page"/> : props.children}

            {footer === false ? null : (footer || (isDefaultLayout ? <PageFooter/> : <Copyright className={styles.copyright}/>))}

            {showSideWidgets && <SideWidgets/>}

            <FloatMiniEntrance/>

            {isDefaultLayout && showOpeningPopup && <OpeningPopup fixedRegisterActive={false}/>}
        </div>
    );
}

export default observer(BaseLayout);
